(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-designer"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const text = JSON.parse($('[data-texts]').dataset.json);
    const form = $('form');
    const productSelect = $('[data-product]');
    const variantSelect = $('[data-variant]');
    const qty = $('[data-quantity]');
    const fileInput = $('[data-file]');
    const submit = $('[data-submit]');
    const canvas = $('canvas');
    const ctx = canvas.getContext('2d');
    const inputs = ['scale','x','y'].map(name => $('[data-' + name + ']'));
    const products = Array.from(productSelect.options).map(option => JSON.parse(option.dataset.productJson));
    let fee = JSON.parse(root.dataset.fee || 'null');
    let product, variant, garmentImage, artwork, file, busy = false, uncertain = false, imageVersion = 0, uploadVersion = 0;
    const money = value => new Intl.NumberFormat('nl-NL', {style:'currency',currency:root.dataset.currency || 'EUR'}).format(value / 100);
    const url = path => root.dataset.root + path;
    const feeVariant = () => fee && fee.variants && fee.variants.find(v => v.available);
    const status = message => { $('[data-status]').textContent = message || ''; };
    const readResponse = async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : text.failed);
      return data;
    };
    const loadImage = source => new Promise((resolve,reject) => {
      const image = new Image();
      if (!source.startsWith('blob:')) image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(text.image_failed));
      image.src = source.startsWith('//') ? 'https:' + source : source;
    });
    const geometry = () => {
      const hoodie = /trui|hoodie|sweater/i.test(product.title);
      const cap = /\b(pet|petten|cap|caps)\b/i.test(product.title);
      const bag = /rugzak|tas|bag|backpack|shopper/i.test(product.title);
      const area = cap ? {x:350,y:370,w:300,h:180} : bag ? {x:350,y:320,w:300,h:300} : hoodie ? {x:340,y:340,w:320,h:260} : {x:320,y:250,w:360,h:410};
      const scale = Number(inputs[0].value) / 100;
      const ratio = artwork.naturalWidth / artwork.naturalHeight;
      const width = Math.min(area.w, area.h * ratio) * scale;
      const height = width / ratio;
      return {x:area.x + (area.w - width) * Number(inputs[1].value) / 100,y:area.y + (area.h - height) * Number(inputs[2].value) / 100,w:width,h:height};
    };
    const draw = () => {
      ctx.clearRect(0,0,1000,1000);
      ctx.fillStyle = '#eee7db';ctx.fillRect(0,0,1000,1000);
      if (garmentImage) {
        const fit = Math.min(1000/garmentImage.naturalWidth,1000/garmentImage.naturalHeight);
        const w=garmentImage.naturalWidth*fit,h=garmentImage.naturalHeight*fit;
        ctx.drawImage(garmentImage,(1000-w)/2,(1000-h)/2,w,h);
      }
      if (artwork && garmentImage) {const g=geometry();ctx.drawImage(artwork,g.x,g.y,g.w,g.h);}
      $('.pm-studio-placeholder').hidden = !!artwork;
    };
    const refresh = () => {
      variant = product && product.variants.find(v => String(v.id) === variantSelect.value);
      const print = feeVariant();
      const quantity = Number(qty.value);
      $('[data-base-price]').textContent = variant && variant.price > 0 ? money(variant.price) : '—';
      $('[data-print-price]').textContent = print ? money(print.price) : '—';
      $('[data-total]').textContent = variant && variant.price > 0 && print && Number.isInteger(quantity) && quantity > 0 ? money((variant.price+print.price)*quantity) : '—';
      $('[data-stock]').textContent = !variant || !variant.available ? text.sold_out : variant.price <= 0 ? text.no_price : text.available;
      submit.disabled = busy || uncertain || !variant || !variant.available || variant.price <= 0 || !print || print.price !== 750 || root.dataset.currency !== 'EUR' || !artwork || !file || !garmentImage || !Number.isInteger(quantity) || quantity < 1 || quantity > 20;
      $('[data-adjust]').disabled = busy || !artwork;
      if (!print || print.price !== 750 || root.dataset.currency !== 'EUR') status(text.service_unavailable);
    };
    const selectProduct = async () => {
      const version = ++imageVersion;
      product = products.find(p => p.handle === productSelect.value);
      if (!product) {status(text.no_products);return;}
      variantSelect.replaceChildren();
      product.variants.forEach(v => {const o=new Option(v.title + (!v.available ? ' — '+text.sold_out : ''),String(v.id));variantSelect.add(o);});
      const preferred=product.variants.find(v=>v.available && v.price>0)||product.variants[0];
      variantSelect.value=String(preferred.id);
      garmentImage = null;status('');draw();refresh();
      try {
        const image = await loadImage(product.featured_image);
        if(version!==imageVersion)return;
        garmentImage=image;draw();refresh();
      } catch(error) {if(version===imageVersion)status(error.message);}
    };
    productSelect.addEventListener('change',selectProduct);
    variantSelect.addEventListener('change',async()=>{refresh();const version=++imageVersion;const selected=variant;const source=selected && selected.featured_image && (selected.featured_image.src||selected.featured_image);try{garmentImage=await loadImage(source||product.featured_image);if(version===imageVersion){draw();refresh();}}catch(error){status(error.message);}});qty.addEventListener('input',refresh);
    inputs.forEach(input=>input.addEventListener('input',draw));
    $('[data-reset]').addEventListener('click',()=>{inputs[0].value=70;inputs[1].value=50;inputs[2].value=40;draw();});
    fileInput.addEventListener('change',async()=>{
      const version=++uploadVersion;
      file=null;artwork=null;draw();refresh();status('');$('[data-file-status]').textContent='';
      const selected=fileInput.files[0];
      if(!selected)return;
      if(!['image/png','image/jpeg','image/webp'].includes(selected.type)||selected.size>10*1024*1024){status(text.bad_file);fileInput.value='';return;}
      const source=URL.createObjectURL(selected);
      try {
        const image=await loadImage(source);
        if(version!==uploadVersion)return;
        if(image.naturalWidth*image.naturalHeight>24000000)throw new Error(text.too_large);
        artwork=image;file=selected;
        $('[data-file-status]').textContent=selected.name+' · '+image.naturalWidth+' × '+image.naturalHeight+' px'+(Math.min(image.naturalWidth,image.naturalHeight)<600?' · '+text.low_resolution:'');
        draw();refresh();
      } catch(error){if(version===uploadVersion){status(error.message);fileInput.value='';}}
      finally{URL.revokeObjectURL(source);}
    });
    const setBusy=value=>{busy=value;productSelect.disabled=value;variantSelect.disabled=value;qty.disabled=value;fileInput.disabled=value;submit.textContent=value?text.adding:text.add;refresh();};
    const getCart=()=>fetch(url('cart.js'),{cache:'no-store'}).then(readResponse);
    const validPair=(items,design,selectedId,quantity)=>{
      const parents=items.filter(i=>i.properties && i.properties._pm_design===design && i.variant_id===selectedId);
      const children=items.filter(i=>i.properties && i.properties._pm_design===design && i.variant_id===feeVariant().id);
      const total=rows=>rows.reduce((sum,i)=>sum+i.quantity,0);
      return parents.length>0 && children.length>0 && total(parents)===quantity && total(children)===quantity && children.every(child=>child.parent_relationship && parents.some(parent=>child.parent_relationship.parent_key===parent.key) && /^https:\/\/[^/]+\/.*\/uploads\//.test(child.properties.Afbeelding||'') && /^https:\/\/[^/]+\/.*\/uploads\//.test(child.properties.Ontwerpvoorbeeld||''));
    };
    form.addEventListener('submit',async event=>{
      event.preventDefault();refresh();if(submit.disabled || !form.reportValidity())return;
      const selectedId=variant.id,quantity=Number(qty.value),design=crypto.randomUUID();
      const oldPrice=variant.price,oldFee=feeVariant().price;
      setBusy(true);status(text.checking);
      let sent=false;
      try {
        const [fresh,freshFee]=await Promise.all([fetch(url('products/'+encodeURIComponent(product.handle)+'.js'),{cache:'no-store'}).then(readResponse),fetch(url('products/'+encodeURIComponent(fee.handle)+'.js'),{cache:'no-store'}).then(readResponse)]);
        Object.assign(product,fresh);fee=freshFee;refresh();
        if(!variant || !variant.available || variant.price<=0 || !feeVariant() || feeVariant().price!==750)throw new Error(text.unavailable);
        if(variant.price!==oldPrice || feeVariant().price!==oldFee)throw new Error(text.price_changed);
        const preview=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
        if(!preview)throw new Error(text.preview_failed);
        const data=new FormData();
        data.append('items[0][id]',String(selectedId));data.append('items[0][quantity]',String(quantity));data.append('items[0][properties][_pm_design]',design);
        data.append('items[1][id]',String(feeVariant().id));data.append('items[1][quantity]',String(quantity));data.append('items[1][parent_id]',String(selectedId));
        const g=geometry();
        const properties={_pm_design:design,_pm_print_service:'true',Kledingstuk:product.title,Maat:variant.title,Zijde:'Voorkant',Plaatsing:JSON.stringify({x:g.x/10,y:g.y/10,breedte:g.w/10,hoogte:g.h/10,eenheid:'% van productfoto'})};
        Object.entries(properties).forEach(([key,value])=>data.append('items[1][properties]['+key+']',value));
        data.append('items[1][properties][Afbeelding]',file,file.name);
        data.append('items[1][properties][Ontwerpvoorbeeld]',preview,'ontwerp-'+design+'.png');
        status(text.adding);sent=true;
        await fetch(url('cart/add.js'),{method:'POST',body:data}).then(readResponse);
        const cart=await getCart();
        if(!validPair(cart.items,design,selectedId,quantity))throw new Error(text.failed);
        window.location.assign(url('cart'));
      } catch(error) {
        if(sent){
          try {
            const cart=await getCart();
            if(validPair(cart.items,design,selectedId,quantity)){window.location.assign(url('cart'));return;}
            const ours=cart.items.filter(i=>i.properties && i.properties._pm_design===design);
            const parent=ours.find(i=>!i.parent_relationship);
            if(parent)await fetch(url('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parent.key,quantity:0})}).then(readResponse);
            const remaining=(await getCart()).items.filter(i=>i.properties && i.properties._pm_design===design);
            for(const item of remaining)await fetch(url('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})}).then(readResponse);
          } catch(cleanupError){uncertain=true;$('[data-recovery]').hidden=false;status(text.uncertain);setBusy(false);return;}
        }
        status(error.message || text.failed);setBusy(false);
      }
    });
    const requested=new URLSearchParams(location.search).get('product');
    if(requested && products.some(p=>p.handle===requested))productSelect.value=requested;
    else {const first=products.find(p=>p.variants.some(v=>v.available && v.price>0));if(first)productSelect.value=first.handle;}
    selectProduct();
  };
  document.querySelectorAll('[data-pm-studio]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pm-studio]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pm-workshop-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('PmWorkshop');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'pm-workshop-2026-10-two-dates';
  const expiry = Date.parse('2026-10-30T00:00:00+01:00');
  let previousFocus;
  const open = () => {
    if (Date.now() >= expiry || dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
  };
  const close = () => dialog.close();
  document.querySelectorAll('[data-workshop-open]').forEach(button => button.addEventListener('click', open));
  dialog.querySelector('[data-workshop-close]').addEventListener('click', close);
  dialog.addEventListener('close', () => {
    try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  });
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
  });
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === 'dismissed'; } catch {}
  if (!dismissed) {
    setTimeout(() => {
      if (document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open]')) return;
      open();
    }, 5000);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
